<script>
import { cloneDeep } from 'lodash-es';
import { mapActions } from 'vuex';
import NonDynamicTransportTripSeatingsRow from './NonDynamicTransportTripSeatingsRow';

export default {
  name: 'NonDynamicTransportTripSeatings',
  components: {
    NonDynamicTransportTripSeatingsRow,
  },
  props: {
    tripId: {
      type: Number,
      default: null,
    },
    defaultTripSeating: {
      type: Object,
      required: true,
    },
    tripSeatings: {
      type: Array,
      default: () => [],
    },
    tripSeatingSectionTypes: {
      type: Array,
      required: true,
    },
    tripSeatingsLoading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      localTripSeatings: [],
    };
  },
  created() {
    if (!this.tripSeatings.length) {
      this.addTripSeatingRow();
    } else {
      this.localTripSeatings = [...this.tripSeatings];
    }
  },
  watch: {
    tripSeatings: {
      handler(value) {
        const updatedTripSeatings = cloneDeep(value);
        this.localTripSeatings = [...updatedTripSeatings];
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions({
      syncTransportTripSeatings: 'nonDynamicTransport/syncTransportTripSeatings',
    }),
    addTripSeatingRow() {
      this.localTripSeatings.push(cloneDeep(this.defaultTripSeating));
    },
    removeTripSeatingRow(index) {
      const tripSeatings = [...this.localTripSeatings];
      tripSeatings.splice(index, 1);
      this.localTripSeatings = [...tripSeatings];
    },
    updateTripSeatingValues(event) {
      const tripSeatings = [...this.localTripSeatings];
      tripSeatings[event.index][event.attribute] = event.value;
      this.localTripSeatings = [...tripSeatings];
    },
    saveTripSeatings() {
      const payload = { tripSeatings: this.localTripSeatings, tripId: this.tripId };
      this.syncTransportTripSeatings(payload);
    },
  },
};
</script>

<template>
  <v-container class="pa-3">
    <v-layout class="mb-2">
      <h3>Seatings</h3>
    </v-layout>
    <v-progress-linear v-if="tripSeatingsLoading" :indeterminate="true"/>
    <non-dynamic-transport-trip-seatings-row
      v-else
      v-for="(tripSeating, index) in localTripSeatings"
      :key="`non-dynamic-trip-seating-${index}`"
      :index="+index"
      :trip-seating="tripSeating"
      :seating-section-types="tripSeatingSectionTypes"
      @add="addTripSeatingRow"
      @remove="removeTripSeatingRow"
      @update="updateTripSeatingValues"
    />
    <v-layout>
      <v-flex>
        <v-btn
          class="right"
          color="success"
          @click="saveTripSeatings"
        >
          Save seating
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/components/non-dynamic-transport/NonDynamicTransportTripSeatings.vue